export default __webpack_public_path__ + "static/media/information--dead-end-left--g2.369ad9b4.png";